interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

const SectionHeader = ({ eyebrow, title, description, align = "center" }: SectionHeaderProps) => {
  const alignClass = align === "center" ? "text-center" : "text-left";

  return (
    <div className={`${alignClass} mb-14 md:mb-20`}>
      {eyebrow && (
        <span className="block font-body text-sm uppercase tracking-widest text-accent mb-4">
          {eyebrow}
        </span>
      )}
      <h2 className="font-headline text-4xl sm:text-[2.75rem] md:text-5xl lg:text-6xl text-foreground leading-tight">
        {title}
      </h2>
      {description && (
        <p className={`mt-6 text-muted-foreground text-lg md:text-xl leading-relaxed ${align === "center" ? "max-w-2xl mx-auto" : "max-w-2xl"}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
